(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flanq-arx6-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (value) => `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(value)}`;

    const initialize = (root) => {
      if (!root || root.dataset.flq6Ready === 'true') return;
      root.dataset.flq6Ready = 'true';

      const basePrice = Number(root.dataset.basePrice || 0);
      const tierTwoPrice = Number(root.dataset.tierTwoPrice || basePrice);
      const tierThreePrice = Number(root.dataset.tierThreePrice || basePrice);
      const quantityInput = root.querySelector('[data-quantity-input]');
      const quantityMessage = root.querySelector('[data-quantity-message]');
      const minus = root.querySelector('[data-quantity-minus]');
      const plus = root.querySelector('[data-quantity-plus]');
      const tiers = [...root.querySelectorAll('[data-tier]')];
      const savings = root.querySelector('[data-savings]');
      const sticky = root.querySelector('[data-flq6-sticky]');
      const productForm = root.querySelector('.flq6-form');
      const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');

      const unitPriceFor = (quantity) => {
        if (quantity >= 3) return tierThreePrice;
        if (quantity === 2) return tierTwoPrice;
        return basePrice;
      };

      const updateQuantity = (nextQuantity) => {
        const quantity = Math.max(1, Number(nextQuantity) || 1);
        const unitPrice = unitPriceFor(quantity);
        const total = unitPrice * quantity;
        const saved = (basePrice - unitPrice) * quantity;

        root.querySelectorAll('[data-quantity-input]').forEach((input) => {
          input.value = String(quantity);
        });
        root.querySelectorAll('[data-quantity-output]').forEach((output) => {
          output.textContent = String(quantity);
        });
        root.querySelectorAll('[data-quantity-minus]').forEach((button) => {
          button.disabled = quantity === 1;
        });
        root.querySelectorAll('[data-add-total]').forEach((totalElement) => {
          totalElement.textContent = money(total);
        });
        root.querySelectorAll('[data-sticky-total]').forEach((totalElement) => {
          totalElement.textContent = money(total);
        });
        root.querySelectorAll('[data-sticky-quantity-output], [data-sticky-quantity-label]').forEach((output) => {
          output.textContent = String(quantity);
        });
        root.querySelectorAll('[data-sticky-quantity-minus]').forEach((button) => {
          button.disabled = quantity === 1;
        });

        root.querySelectorAll('[data-tier]').forEach((tier) => {
          const tierQuantity = Number(tier.dataset.tierQuantity);
          const selected = tierQuantity === 3 ? quantity >= 3 : quantity === tierQuantity;
          tier.classList.toggle('is-selected', selected);
          tier.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        root.querySelectorAll('[data-tier-three-total]').forEach((tierThreeTotal) => {
          const displayQuantity = quantity >= 3 ? quantity : 3;
          tierThreeTotal.textContent = `${money(tierThreePrice * displayQuantity)} total · save ${money((basePrice - tierThreePrice) * displayQuantity)}`;
        });

        if (quantityMessage) {
          quantityMessage.textContent =
            quantity >= 3
              ? `${money(basePrice - tierThreePrice)} off every case`
              : quantity === 2
                ? `${money(basePrice - tierTwoPrice)} off every case`
                : 'Choose what fits your collection';
        }

        if (savings) {
          savings.classList.toggle('is-hidden', saved <= 0);
          const strong = savings.querySelector('strong');
          if (strong) strong.textContent = money(saved);
        }

        document.dispatchEvent(
          new CustomEvent('flq-arx6:quantity', {
            detail: { quantity, unitPrice, total }
          })
        );
      };

      tiers.forEach((tier) => {
        tier.addEventListener('click', () => updateQuantity(Number(tier.dataset.tierQuantity)));
      });
      minus?.addEventListener('click', () => updateQuantity(Number(quantityInput?.value || 1) - 1));
      plus?.addEventListener('click', () => updateQuantity(Number(quantityInput?.value || 1) + 1));
      root.querySelector('[data-sticky-quantity-minus]')?.addEventListener('click', () => updateQuantity(Number(quantityInput?.value || 1) - 1));
      root.querySelector('[data-sticky-quantity-plus]')?.addEventListener('click', () => updateQuantity(Number(quantityInput?.value || 1) + 1));
      root.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
        const submit = root.querySelector('.flq6-add:not([disabled])');
        if (productForm && submit) {
          productForm.requestSubmit(submit);
        }
      });

      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const mainImage = root.querySelector('.flq6-gallery__main');
      const position = root.querySelector('[data-gallery-position]');
      let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

      const showImage = (index) => {
        if (!thumbs.length || !mainImage) return;
        activeIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[activeIndex];
        mainImage.classList.add('is-changing');
        window.setTimeout(() => {
          mainImage.src = thumb.dataset.imageUrl;
          mainImage.removeAttribute('srcset');
          mainImage.alt = thumb.dataset.imageAlt || '';
          mainImage.classList.remove('is-changing');
        }, 100);
        thumbs.forEach((item, itemIndex) => {
          const selected = itemIndex === activeIndex;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-current', selected ? 'true' : 'false');
        });
        if (position) {
          position.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
        }
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
      root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => showImage(activeIndex - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));

      if (sticky && productForm && 'IntersectionObserver' in window) {
        let footerVisible = false;
        let formPassed = false;
        const syncSticky = () => {
          const visible = formPassed && !footerVisible;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        };
        const formObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          const rect = entry.target.getBoundingClientRect();
          formPassed = !entry.isIntersecting && rect.bottom < 0;
          syncSticky();
        });
        formObserver.observe(productForm);
        if (footer) {
          const footerObserver = new IntersectionObserver((entries) => {
            footerVisible = Boolean(entries[0]?.isIntersecting);
            syncSticky();
          }, { rootMargin: '180px 0px 0px 0px' });
          footerObserver.observe(footer);
        }
      }

      updateQuantity(Number(quantityInput?.value || 1));
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-flq6-buybox]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-arx6-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindGiftButtons = (scope = document) => {
      scope.querySelectorAll('[data-flq6-gift-cta]:not([data-ready])').forEach((button) => {
        button.dataset.ready = 'true';
        button.addEventListener('click', () => {
          const root = document.querySelector('[data-flq6-buybox]');
          const quantity = Math.max(1, Number(button.dataset.quantity || 2));
          const tier =
            quantity >= 3
              ? root?.querySelector('[data-tier-quantity="3"]')
              : root?.querySelector(`[data-tier-quantity="${quantity}"]`);
          tier?.click();
          root?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindGiftButtons());
    } else {
      bindGiftButtons();
    }
    document.addEventListener('shopify:section:load', (event) => bindGiftButtons(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-arx6-reviews-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.reviewsReady === 'true') return;
      root.dataset.reviewsReady = 'true';

      const grid = root.querySelector('[data-review-grid]');
      let cards = grid ? [...grid.querySelectorAll('[data-review-card]')] : [];
      const ratingFilter = root.querySelector('[data-review-rating-filter]');
      const mediaFilter = root.querySelector('[data-review-media-filter]');
      const verifiedFilter = root.querySelector('[data-review-verified-filter]');
      const sort = root.querySelector('[data-review-sort]');
      const loadMore = root.querySelector('[data-review-load-more]');
      const empty = root.querySelector('[data-review-empty]');
      const noReviews = root.querySelector('[data-review-no-reviews]');
      const resultCount = root.querySelector('[data-review-result-count]');
      const mediaGrid = root.querySelector('[data-review-media-grid]');
      const pageSize = Math.max(1, Number(grid?.dataset.pageSize || 6));
      const verifiedLabel = root.dataset.verifiedLabel || 'Verified purchase';
      const mediaAlt = root.dataset.customerMediaAlt || 'Customer photo of ARX6';
      const productId = String(root.dataset.productId || '');
      const productHandle = root.dataset.productHandle || '';
      let visibleLimit = pageSize;

      const mediaSource = (media) => {
        const source = typeof media === 'string'
          ? media
          : media?.source || media?.url || media?.src || media?.preview_image?.src || '';
        if (!source) return '';
        try {
          const parsed = new URL(source, window.location.href);
          return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : '';
        } catch (_error) {
          return '';
        }
      };

      const formatDate = (value) => {
        if (!value) return '';
        const numericValue = Number(value);
        const date = new Date(Number.isFinite(numericValue) ? numericValue : value);
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }).format(date);
      };

      const createMediaButton = (source, className = '') => {
        const url = mediaSource(source);
        if (!url) return null;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.reviewMediaOpen = '';
        button.setAttribute('aria-label', 'Open customer photo');
        if (className) button.className = className;
        const image = document.createElement('img');
        image.src = url;
        image.width = 700;
        image.height = 700;
        image.loading = 'lazy';
        image.alt = mediaAlt;
        button.appendChild(image);
        return button;
      };

      const appendReviewCard = (review, index) => {
        if (!grid || !review || (!review.content && !review.title)) return;
        const reviewId = String(review.id || `doran-${index}`);
        if (grid.querySelector(`[data-doran-review-id="${CSS.escape(reviewId)}"]`)) return;

        const rating = Math.min(5, Math.max(1, Math.round(Number(review.stars || review.rating || 5))));
        const reviewMedia = Array.isArray(review.mediaFiles) ? review.mediaFiles : [];
        const card = document.createElement('article');
        card.className = 'flq6-proof__card';
        card.dataset.reviewCard = '';
        card.dataset.doranReviewId = reviewId;
        card.dataset.reviewRating = String(rating);
        card.dataset.reviewVerified = review.isVerifiedPurchase ? 'true' : 'false';
        card.dataset.reviewMedia = reviewMedia.some(mediaSource) ? 'true' : 'false';
        card.dataset.reviewOrder = String(index + 100);

        const head = document.createElement('div');
        head.className = 'flq6-proof__card-head';
        const stars = document.createElement('span');
        stars.className = 'flq6-proof__card-stars';
        stars.setAttribute('aria-label', `${rating} out of 5 stars`);
        for (let star = 1; star <= 5; star += 1) {
          const starElement = document.createElement('span');
          starElement.textContent = '★';
          if (star > rating) starElement.className = 'is-empty';
          stars.appendChild(starElement);
        }
        head.appendChild(stars);
        if (review.isVerifiedPurchase) {
          const verified = document.createElement('span');
          verified.className = 'flq6-proof__verified';
          verified.textContent = `✓ ${verifiedLabel}`;
          head.appendChild(verified);
        }
        card.appendChild(head);

        const mediaButtons = reviewMedia.slice(0, 3).map((media) => createMediaButton(media)).filter(Boolean);
        if (mediaButtons.length) {
          const mediaRow = document.createElement('div');
          mediaRow.className = 'flq6-proof__card-media flq6-proof__card-media--row';
          mediaButtons.forEach((button) => mediaRow.appendChild(button));
          card.appendChild(mediaRow);
        }

        if (review.title) {
          const title = document.createElement('h3');
          title.textContent = review.title;
          card.appendChild(title);
        }
        if (review.content) {
          const quote = document.createElement('div');
          quote.className = 'flq6-proof__quote';
          quote.textContent = review.content;
          card.appendChild(quote);
        }

        const footer = document.createElement('footer');
        const author = document.createElement('strong');
        author.textContent = review.authorName || 'Flanq customer';
        footer.appendChild(author);
        if (review.country) {
          const country = document.createElement('span');
          country.textContent = review.country;
          footer.appendChild(country);
        }
        const dateText = formatDate(review.createdAt);
        if (dateText) {
          const date = document.createElement('span');
          date.textContent = dateText;
          footer.appendChild(date);
        }
        card.appendChild(footer);
        grid.appendChild(card);
      };

      const appendCustomerMedia = (mediaFiles) => {
        if (!mediaGrid || !Array.isArray(mediaFiles)) return;
        const existingSources = new Set(
          [...mediaGrid.querySelectorAll('img')].map((image) => image.currentSrc || image.src)
        );
        let remaining = Math.max(0, 8 - existingSources.size);
        mediaFiles.forEach((media) => {
          if (remaining <= 0) return;
          const source = mediaSource(media);
          if (!source || existingSources.has(source)) return;
          const button = createMediaButton(source, 'flq6-proof__media-tile');
          if (!button) return;
          mediaGrid.appendChild(button);
          existingSources.add(source);
          remaining -= 1;
        });
      };

      const filteredCards = () => {
        const rating = ratingFilter?.value || 'all';
        const mediaOnly = Boolean(mediaFilter?.checked);
        const verifiedOnly = Boolean(verifiedFilter?.checked);
        return cards.filter((card) => {
          if (rating !== 'all' && card.dataset.reviewRating !== rating) return false;
          if (mediaOnly && card.dataset.reviewMedia !== 'true') return false;
          if (verifiedOnly && card.dataset.reviewVerified !== 'true') return false;
          return true;
        });
      };

      const apply = () => {
        const matches = filteredCards();
        const direction = sort?.value || 'recent';
        const ordered = [...matches].sort((first, second) => {
          if (direction === 'highest') return Number(second.dataset.reviewRating) - Number(first.dataset.reviewRating);
          if (direction === 'lowest') return Number(first.dataset.reviewRating) - Number(second.dataset.reviewRating);
          return Number(first.dataset.reviewOrder) - Number(second.dataset.reviewOrder);
        });
        const matchedSet = new Set(matches);
        cards.forEach((card) => {
          card.hidden = true;
        });
        ordered.forEach((card, index) => {
          grid?.appendChild(card);
          card.hidden = index >= visibleLimit;
        });
        if (empty) empty.hidden = matches.length > 0;
        if (loadMore) loadMore.hidden = matches.length <= visibleLimit;
        if (resultCount) {
          const shown = Math.min(matches.length, visibleLimit);
          resultCount.textContent = matches.length ? `Showing ${shown} of ${matches.length} reviews` : '';
        }
        if (noReviews) noReviews.hidden = cards.length > 0;
        cards.filter((card) => !matchedSet.has(card)).forEach((card) => {
          card.hidden = true;
        });
      };

      [ratingFilter, mediaFilter, verifiedFilter, sort].forEach((control) => {
        control?.addEventListener('change', () => {
          visibleLimit = pageSize;
          apply();
        });
      });

      root.querySelectorAll('[data-review-rating-button]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!ratingFilter) return;
          ratingFilter.value = button.dataset.reviewRatingButton || 'all';
          visibleLimit = pageSize;
          apply();
          ratingFilter.focus();
        });
      });

      loadMore?.addEventListener('click', () => {
        visibleLimit += pageSize;
        apply();
      });

      const lightbox = root.querySelector('[data-review-lightbox]');
      const lightboxImage = lightbox?.querySelector('img');
      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-review-media-open]');
        if (!button || !root.contains(button)) return;
        const image = button.querySelector('img');
        if (!lightbox || !lightboxImage || !image) return;
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt;
        lightbox.showModal();
      });
      root.querySelector('[data-review-media-close]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });

      root.querySelector('[data-review-write]')?.addEventListener('click', (event) => {
        const openReviewModal = window.$prDoranInit?.customDispatch?.openReviewModal;
        const setReviewModalStep = window.$prDoranInit?.customDispatch?.setReviewModalStep;
        if (typeof openReviewModal === 'function') {
          event.preventDefault();
          openReviewModal(true);
          if (typeof setReviewModalStep === 'function') setReviewModalStep('Content');
          return;
        }
        if (window.location.hash !== '#pr_write_review') return;
        event.preventDefault();
        window.location.hash = '';
        window.setTimeout(() => {
          window.location.hash = 'pr_write_review';
        }, 20);
      });

      apply();

      const hydrateDoran = (attempt = 0) => {
        const doran = window.$prDoranInit;
        const productMap = doran?.widgetProduct || {};
        const reviewMap = doran?.productWidgetReview || {};
        let resolvedId = productId;

        if (!productMap[resolvedId] && productHandle) {
          resolvedId = Object.keys(productMap).find((key) => productMap[key]?.handle === productHandle) || resolvedId;
        }

        const productData = productMap[resolvedId];
        const reviewData = reviewMap[resolvedId];
        if (productData || reviewData) {
          appendCustomerMedia(productData?.mediaFiles || []);
          (reviewData?.nodes || []).forEach(appendReviewCard);
          cards = grid ? [...grid.querySelectorAll('[data-review-card]')] : [];
          visibleLimit = pageSize;
          apply();
          return;
        }

        if (attempt < 40) {
          window.setTimeout(() => hydrateDoran(attempt + 1), 100);
        } else if (noReviews) {
          noReviews.hidden = cards.length > 0;
        }
      };

      hydrateDoran();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-flq6-reviews]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-mr-bones-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const initialize = (root) => {
      if (!root || initialized.has(root)) return;
      initialized.add(root);

      const base = Number(root.dataset.basePricePaise || 0);
      const tierTwo = Number(root.dataset.tierTwoPricePaise || base);
      const tierThree = Number(root.dataset.tierThreePricePaise || base);
      const verified = root.dataset.volumeVerified === 'true';
      const currency = root.dataset.currency || 'INR';
      const quantityInput = root.querySelector('[data-quantity-input]');
      const tiers = [...root.querySelectorAll('[data-tier]')];
      const mainSubmit = root.querySelector('.flqmb-add');
      const sticky = root.querySelector('[data-flqmb-sticky]');
      const productForm = root.querySelector('.flqmb-form');
      const footer = document.querySelector('footer');

      const money = (paise) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
            style: 'currency',
            currency,
            maximumFractionDigits: paise % 100 === 0 ? 0 : 2
          }).format(paise / 100);
        } catch (error) {
          return `₹${Math.round(paise / 100).toLocaleString('en-IN')}`;
        }
      };

      const unitFor = (quantity) => {
        if (!verified) return base;
        if (quantity >= 3) return tierThree;
        if (quantity === 2) return tierTwo;
        return base;
      };

      const update = (nextQuantity, announce = true) => {
        const quantity = Math.max(1, Math.floor(Number(nextQuantity) || 1));
        const unit = unitFor(quantity);
        const total = unit * quantity;
        const saving = Math.max(0, (base - unit) * quantity);

        quantityInput.value = String(quantity);
        root.querySelector('[data-quantity-minus]').disabled = quantity === 1;
        root.querySelector('[data-sticky-minus]')?.toggleAttribute('disabled', quantity === 1);
        root.querySelectorAll('[data-sticky-output], [data-sticky-quantity-label]').forEach((node) => {
          node.textContent = String(quantity);
        });
        root.querySelectorAll('[data-sticky-total], [data-add-total]').forEach((node) => {
          node.textContent = money(total);
        });

        tiers.forEach((tier, index) => {
          const threshold = Number(tier.dataset.tierQuantity);
          const selected = threshold === 3 ? quantity >= 3 : quantity === threshold;
          tier.classList.toggle('is-selected', selected);
          tier.setAttribute('aria-checked', selected ? 'true' : 'false');
          tier.tabIndex = selected ? 0 : -1;

          const displayQuantity = threshold === 3 ? Math.max(3, quantity) : threshold;
          const displayUnit = unitFor(displayQuantity);
          const displayTotal = displayUnit * displayQuantity;
          const displaySaving = Math.max(0, (base - displayUnit) * displayQuantity);
          tier.querySelector('[data-tier-total]').textContent = `${money(displayTotal)} total`;
          tier.querySelector('[data-tier-each]').textContent =
            `${money(displayUnit)} each${verified && displaySaving > 0 ? ` · Save ${money(displaySaving)}` : ''}`;

          if (selected && document.activeElement?.matches('[data-tier]') && document.activeElement !== tier && index >= 0) {
            tier.focus();
          }
        });

        const savings = root.querySelector('[data-savings]');
        if (savings) {
          savings.hidden = !verified || saving <= 0;
          const copy = savings.querySelector('[data-savings-copy]');
          if (copy) copy.textContent = `You save ${money(saving)} — ${money(base - unit)} off each Mr. Bones.`;
        }

        if (announce) {
          root.dispatchEvent(new CustomEvent('flanq:mr-bones:quantity', {
            bubbles: true,
            detail: { quantity, unitPricePaise: unit, totalPaise: total, savingPaise: saving, verified }
          }));
        }
      };

      tiers.forEach((tier) => {
        tier.addEventListener('click', () => {
          const threshold = Number(tier.dataset.tierQuantity);
          const current = Number(quantityInput.value || 1);
          update(threshold === 3 ? Math.max(3, current) : threshold);
        });
      });
      root.querySelector('[data-tier-group]')?.addEventListener('keydown', (event) => {
        const currentIndex = tiers.indexOf(document.activeElement);
        if (currentIndex < 0) return;
        let nextIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % tiers.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + tiers.length) % tiers.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tiers.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        tiers[nextIndex].click();
        tiers[nextIndex].focus();
      });
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => update(Number(quantityInput.value) - 1));
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => update(Number(quantityInput.value) + 1));
      quantityInput?.addEventListener('change', () => update(quantityInput.value));
      quantityInput?.addEventListener('input', () => {
        if (quantityInput.value !== '') update(quantityInput.value, false);
      });
      root.querySelector('[data-sticky-minus]')?.addEventListener('click', () => update(Number(quantityInput.value) - 1));
      root.querySelector('[data-sticky-plus]')?.addEventListener('click', () => update(Number(quantityInput.value) + 1));

      const gallery = root.querySelector('[data-flqmb-gallery]');
      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      let active = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      let touchStart = null;
      const showSlide = (next) => {
        if (slides.length < 1) return;
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          slide.hidden = index !== active;
          if (index !== active) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbs.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === active);
          thumb.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
        const counter = root.querySelector('[data-gallery-counter]');
        if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        const track = root.querySelector('[data-gallery-track]');
        if (track) track.style.width = `${((active + 1) / slides.length) * 100}%`;
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.galleryTarget) - 1)));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(active - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(active + 1));
      gallery?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(active - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(active + 1); }
      });
      gallery?.addEventListener('touchstart', (event) => { touchStart = event.touches[0]?.clientX ?? null; }, { passive: true });
      gallery?.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const delta = (event.changedTouches[0]?.clientX ?? touchStart) - touchStart;
        touchStart = null;
        if (Math.abs(delta) > 44) showSlide(delta < 0 ? active + 1 : active - 1);
      }, { passive: true });

      const lightbox = root.querySelector('[data-gallery-lightbox]');
      root.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
        if (!lightbox || typeof lightbox.showModal !== 'function') return;
        const content = lightbox.querySelector('[data-gallery-lightbox-content]');
        const source = slides[active]?.querySelector('img, video');
        if (!content || !source) return;
        content.replaceChildren(source.cloneNode(true));
        lightbox.showModal();
      });
      root.querySelector('[data-gallery-close]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });

      if (sticky && productForm && 'IntersectionObserver' in window) {
        let formPassed = false;
        let footerVisible = false;
        const syncSticky = () => {
          const visible = formPassed && !footerVisible && !document.body.classList.contains('overflow-hidden');
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        };
        const formObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          formPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          syncSticky();
        });
        formObserver.observe(productForm);
        if (footer) {
          const footerObserver = new IntersectionObserver((entries) => {
            footerVisible = Boolean(entries[0]?.isIntersecting);
            syncSticky();
          }, { rootMargin: '180px 0px 0px 0px' });
          footerObserver.observe(footer);
        }
        new MutationObserver(syncSticky).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }

      showSlide(active);
      update(1, false);
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqmb-buybox]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-mr-bones-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const initialize = (root) => {
      if (!root || initialized.has(root)) return;
      initialized.add(root);
      document.addEventListener('flanq:mr-bones:quantity', (event) => {
        const quantity = Number(event.detail?.quantity || 1);
        root.querySelectorAll('[data-multi-state]').forEach((node) => {
          if (quantity === 1) node.textContent = 'One selected for your everyday carry.';
          else if (quantity === 2) node.textContent = 'Two selected: keep one and hand one over.';
          else node.textContent = `${quantity} selected: the Buy 3+ tier stays active.`;
        });
      });
    };
    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqmbs-story]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-pixo-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (paise) => `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(paise / 100))}`;

    const initialize = (root) => {
      if (!root || root.dataset.flqpReady === 'true') return;
      root.dataset.flqpReady = 'true';

      const basePrice = Number(root.dataset.basePrice || 0);
      const tierTwoPrice = Number(root.dataset.tierTwoPrice || basePrice);
      const tierThreePrice = Number(root.dataset.tierThreePrice || basePrice);
      const discountReady = root.dataset.discountReady === 'true';
      const eachLabel = root.dataset.eachLabel || 'each';
      const totalLabel = root.dataset.totalLabel || 'total';
      const saveLabel = root.dataset.saveLabel || 'Save';
      const quantityInput = root.querySelector('[data-quantity-input]');
      const visibleInput = root.querySelector('[data-quantity-visible]');
      const tiers = [...root.querySelectorAll('[data-tier]')];
      const productForm = root.querySelector('.flqp-form');
      const sticky = root.querySelector('[data-flqp-sticky]');
      const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');

      const unitFor = (quantity) => {
        if (!discountReady) return basePrice;
        if (quantity >= 3) return tierThreePrice;
        if (quantity === 2) return tierTwoPrice;
        return basePrice;
      };

      const update = (nextQuantity, announce = true) => {
        const quantity = Math.max(1, Math.floor(Number(nextQuantity)) || 1);
        const unitPrice = unitFor(quantity);
        const total = unitPrice * quantity;
        const saving = discountReady ? (basePrice - unitPrice) * quantity : 0;

        if (quantityInput) quantityInput.value = String(quantity);
        if (visibleInput && visibleInput.value !== String(quantity)) visibleInput.value = String(quantity);
        root.querySelectorAll('[data-quantity-minus]').forEach((button) => { button.disabled = quantity === 1; });
        root.querySelectorAll('[data-add-total], [data-sticky-total]').forEach((node) => { node.textContent = formatMoney(total); });
        root.querySelectorAll('[data-sticky-quantity]').forEach((node) => { node.textContent = String(quantity); });

        tiers.forEach((tier, index) => {
          const tierQuantity = Number(tier.dataset.tierQuantity);
          const selected = tierQuantity === 3 ? quantity >= 3 : quantity === tierQuantity;
          tier.classList.toggle('is-selected', selected);
          tier.setAttribute('aria-checked', selected ? 'true' : 'false');
          tier.tabIndex = selected ? 0 : -1;
          if (selected) root.dataset.selectedTierIndex = String(index);
        });

        const message = root.querySelector('[data-quantity-message]');
        if (message) {
          message.textContent = saving > 0
            ? `${saveLabel} ${formatMoney(saving)} · ${formatMoney(unitPrice)} ${eachLabel}`
            : root.dataset.singleNote;
        }
        const savings = root.querySelector('[data-savings]');
        if (savings) {
          savings.hidden = saving <= 0;
          const copy = savings.querySelector('[data-savings-copy]');
          if (copy) copy.textContent = `${saveLabel} ${formatMoney(saving)} · ${formatMoney(basePrice - unitPrice)} off ${eachLabel}`;
        }

        document.dispatchEvent(new CustomEvent('flanq:pixo:quantity', {
          detail: { quantity, unitPrice, total, saving, discountReady, totalLabel }
        }));

        if (announce && visibleInput) {
          visibleInput.setAttribute('aria-valuetext', `${quantity}. ${formatMoney(total)} ${totalLabel}`);
        }
      };

      tiers.forEach((tier) => {
        tier.addEventListener('click', () => update(Number(tier.dataset.tierQuantity)));
        tier.addEventListener('keydown', (event) => {
          const current = tiers.indexOf(event.currentTarget);
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tiers.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tiers.length) % tiers.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tiers.length - 1;
          if (next === null) return;
          event.preventDefault();
          tiers[next].focus();
          update(Number(tiers[next].dataset.tierQuantity));
        });
      });
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => update(Number(quantityInput?.value || 1) - 1));
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => update(Number(quantityInput?.value || 1) + 1));
      visibleInput?.addEventListener('change', () => update(visibleInput.value));
      visibleInput?.addEventListener('blur', () => update(visibleInput.value, false));
      root.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
        const submit = root.querySelector('.flqp-add:not([disabled])');
        if (productForm && submit) productForm.requestSubmit(submit);
      });

      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const counter = root.querySelector('[data-gallery-counter]');
      let activeIndex = 0;
      let touchStart = null;
      const showSlide = (requested) => {
        if (slides.length < 2) return;
        activeIndex = (requested + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === activeIndex;
          slide.hidden = !selected;
          slide.classList.toggle('is-active', selected);
          if (!selected) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbs.forEach((thumb, index) => {
          const selected = index === activeIndex;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-current', selected ? 'true' : 'false');
        });
        if (counter) counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
      const stage = root.querySelector('.flqp-gallery__stage');
      stage?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(activeIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(activeIndex + 1); }
      });
      stage?.addEventListener('touchstart', (event) => { touchStart = event.touches[0]?.clientX ?? null; }, { passive: true });
      stage?.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const delta = (event.changedTouches[0]?.clientX ?? touchStart) - touchStart;
        touchStart = null;
        if (Math.abs(delta) > 44) showSlide(activeIndex + (delta < 0 ? 1 : -1));
      }, { passive: true });

      if (sticky && productForm && 'IntersectionObserver' in window) {
        let formPassed = false;
        let footerVisible = false;
        const syncSticky = () => {
          const overlayOpen = Boolean(document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], [role="dialog"][open]'));
          sticky.classList.toggle('is-visible', formPassed && !footerVisible);
          sticky.classList.toggle('is-suppressed', overlayOpen);
          sticky.setAttribute('aria-hidden', formPassed && !footerVisible && !overlayOpen ? 'false' : 'true');
        };
        new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          formPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          syncSticky();
        }).observe(productForm);
        if (footer) {
          new IntersectionObserver((entries) => {
            footerVisible = Boolean(entries[0]?.isIntersecting);
            syncSticky();
          }, { rootMargin: '180px 0px 0px 0px' }).observe(footer);
        }
        const overlayNodes = [
          document.body,
          ...document.querySelectorAll('cart-drawer, cart-notification, dialog, [role="dialog"]')
        ];
        const overlayObserver = new MutationObserver(syncSticky);
        overlayNodes.forEach((node) => {
          overlayObserver.observe(node, { attributes: true, attributeFilter: ['class', 'open'] });
        });
      }

      update(1, false);
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqp-buybox]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-pixo-moodshift"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.flqpMoodReady === 'true') return;
      root.dataset.flqpMoodReady = 'true';
      root.classList.add('is-ready');
      const controls = [...root.querySelectorAll('[data-mood-control]')];
      const panels = [...root.querySelectorAll('[data-mood-panel]')];
      if (!controls.length || !panels.length) return;

      const select = (index, focus = false) => {
        controls.forEach((control, controlIndex) => {
          const selected = controlIndex === index;
          control.classList.toggle('is-active', selected);
          control.setAttribute('aria-checked', selected ? 'true' : 'false');
          control.tabIndex = selected ? 0 : -1;
          if (selected && focus) control.focus();
        });
        panels.forEach((panel, panelIndex) => {
          const selected = panelIndex === index;
          panel.classList.toggle('is-active', selected);
          panel.querySelectorAll('video').forEach((video) => {
            if (!selected) video.pause();
          });
        });
      };

      controls.forEach((control, index) => {
        control.addEventListener('click', () => select(index));
        control.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % controls.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + controls.length) % controls.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = controls.length - 1;
          if (next === null) return;
          event.preventDefault();
          select(next, true);
        });
      });
      select(0);
    };
    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqp-mood]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-pixo-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.flqpStoryReady === 'true') return;
      root.dataset.flqpStoryReady = 'true';
      const output = root.querySelector('[data-pixo-repeat-total]');
      if (!output) return;
      document.addEventListener('flanq:pixo:quantity', (event) => {
        const detail = event.detail || {};
        if (!detail.discountReady || Number(detail.quantity) < 2) {
          output.hidden = true;
          output.textContent = '';
          return;
        }
        const money = (paise) => `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(Number(paise) / 100))}`;
        output.textContent = `${detail.quantity} × ${money(detail.unitPrice)} = ${money(detail.total)} · save ${money(detail.saving)}`;
        output.hidden = false;
      });
    };
    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqp-story]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-sartelle-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.flqsrtReady === 'true') return;
      root.dataset.flqsrtReady = 'true';

      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const counter = root.querySelector('[data-gallery-counter]');
      const stage = root.querySelector('[data-gallery-stage]');
      const zoomButton = root.querySelector('[data-gallery-zoom]');
      const lightbox = root.querySelector('[data-gallery-lightbox]');
      const lightboxImage = root.querySelector('[data-lightbox-image]');
      let activeIndex = 0;
      let touchStart = null;

      const syncZoom = () => {
        if (!zoomButton) return;
        const slide = slides[activeIndex];
        zoomButton.hidden = !slide?.dataset.zoomSrc;
      };

      const showSlide = (requested) => {
        if (!slides.length) return;
        activeIndex = (requested + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === activeIndex;
          slide.hidden = !selected;
          slide.classList.toggle('is-active', selected);
          if (!selected) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbs.forEach((thumb, index) => {
          const selected = index === activeIndex;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-current', selected ? 'true' : 'false');
        });
        if (counter) counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        syncZoom();
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
      stage?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(activeIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(activeIndex + 1); }
      });
      stage?.addEventListener('touchstart', (event) => { touchStart = event.touches[0]?.clientX ?? null; }, { passive: true });
      stage?.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const delta = (event.changedTouches[0]?.clientX ?? touchStart) - touchStart;
        touchStart = null;
        if (Math.abs(delta) > 44) showSlide(activeIndex + (delta < 0 ? 1 : -1));
      }, { passive: true });

      zoomButton?.addEventListener('click', () => {
        const slide = slides[activeIndex];
        if (!slide?.dataset.zoomSrc || !lightbox || !lightboxImage) return;
        lightboxImage.src = slide.dataset.zoomSrc;
        lightboxImage.alt = slide.dataset.zoomAlt || '';
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      });
      root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });

      const basePrice = Number(root.dataset.basePrice || 0);
      const priceConfigured = basePrice > 0;
      const tierTwoPrice = Number(root.dataset.tierTwoPrice || basePrice);
      const tierThreePrice = Number(root.dataset.tierThreePrice || basePrice);
      const discountReady = root.dataset.discountReady === 'true';
      const eachLabel = root.dataset.eachLabel || 'each';
      const totalLabel = root.dataset.totalLabel || 'total';
      const saveLabel = root.dataset.saveLabel || 'You save';
      const currency = root.dataset.currency || 'INR';
      const locale = root.dataset.locale || 'en-IN';
      const quantityInput = root.querySelector('[data-quantity-input]');
      const tiers = [...root.querySelectorAll('[data-tier]')];

      const formatMoney = (paise) => {
        const amount = Math.round(Number(paise) || 0) / 100;
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(amount);
        } catch (_error) {
          return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(amount)}`;
        }
      };

      const unitFor = (quantity) => {
        if (!discountReady) return basePrice;
        if (quantity >= 3) return tierThreePrice;
        if (quantity === 2) return tierTwoPrice;
        return basePrice;
      };

      const updateQuantity = (nextQuantity, announce = true) => {
        const quantity = Math.max(1, Math.floor(Number(nextQuantity)) || 1);
        const unitPrice = unitFor(quantity);
        const total = unitPrice * quantity;
        const saving = discountReady ? (basePrice - unitPrice) * quantity : 0;

        if (quantityInput) quantityInput.value = String(quantity);
        root.querySelectorAll('[data-quantity-minus]').forEach((button) => {
          button.disabled = quantity === 1;
        });
        if (priceConfigured) {
          root.querySelectorAll('[data-add-total], [data-sticky-total]').forEach((node) => {
            node.textContent = formatMoney(total);
          });
        }
        root.querySelectorAll('[data-sticky-quantity]').forEach((node) => {
          node.textContent = String(quantity);
        });

        tiers.forEach((tier) => {
          const tierQuantity = Number(tier.dataset.tierQuantity);
          const selected = tierQuantity === 3 ? quantity >= 3 : quantity === tierQuantity;
          tier.classList.toggle('is-selected', selected);
          tier.setAttribute('aria-checked', selected ? 'true' : 'false');
          tier.tabIndex = selected ? 0 : -1;
        });

        const quantityMessage = root.querySelector('[data-quantity-message]');
        if (quantityMessage) {
          quantityMessage.textContent = saving > 0
            ? `${saveLabel} ${formatMoney(saving)} · ${formatMoney(unitPrice)} ${eachLabel}`
            : root.dataset.singleNote;
        }

        const savings = root.querySelector('[data-savings]');
        if (savings) {
          savings.hidden = saving <= 0;
          const copy = savings.querySelector('[data-savings-copy]');
          if (copy) {
            copy.textContent = `${saveLabel} ${formatMoney(saving)} · ${formatMoney(basePrice - unitPrice)} ${root.dataset.offEachLabel || `off ${eachLabel}`}`;
          }
        }

        if (announce && quantityInput) {
          quantityInput.setAttribute('aria-valuetext', `${quantity}. ${formatMoney(total)} ${totalLabel}`);
        }

        document.dispatchEvent(new CustomEvent('flanq:sartelle:quantity', {
          detail: { quantity, unitPrice, total, saving, discountReady }
        }));
      };

      tiers.forEach((tier) => {
        tier.addEventListener('click', () => updateQuantity(Number(tier.dataset.tierQuantity)));
        tier.addEventListener('keydown', (event) => {
          const current = tiers.indexOf(event.currentTarget);
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tiers.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tiers.length) % tiers.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tiers.length - 1;
          if (next === null) return;
          event.preventDefault();
          tiers[next].focus();
          updateQuantity(Number(tiers[next].dataset.tierQuantity));
        });
      });
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        updateQuantity(Number(quantityInput?.value || 1) - 1);
      });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        updateQuantity(Number(quantityInput?.value || 1) + 1);
      });
      quantityInput?.addEventListener('input', () => {
        if (quantityInput.value !== '') updateQuantity(quantityInput.value);
      });
      quantityInput?.addEventListener('blur', () => updateQuantity(quantityInput.value, false));

      const mainSubmit = root.querySelector('[data-main-submit]');
      const sticky = root.querySelector('[data-flqsrt-sticky]');

      if (sticky && mainSubmit && 'IntersectionObserver' in window) {
        const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
        let ctaPassed = false;
        let footerVisible = false;
        const syncSticky = () => {
          const overlayOpen = Boolean(document.querySelector(
            'cart-drawer.active, cart-notification.active, dialog[open], [role="dialog"][open], .menu-opening'
          )) || getComputedStyle(document.body).overflow === 'hidden';
          sticky.classList.toggle('is-visible', ctaPassed && !footerVisible);
          sticky.classList.toggle('is-suppressed', overlayOpen);
          sticky.setAttribute('aria-hidden', ctaPassed && !footerVisible && !overlayOpen ? 'false' : 'true');
        };
        new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          ctaPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          syncSticky();
        }).observe(mainSubmit);
        if (footer) {
          new IntersectionObserver((entries) => {
            footerVisible = Boolean(entries[0]?.isIntersecting);
            syncSticky();
          }, { rootMargin: '180px 0px 0px 0px' }).observe(footer);
        }
        const overlayObserver = new MutationObserver(syncSticky);
        overlayObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
      }

      showSlide(0);
      updateQuantity(1, false);
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqsrt-buybox]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flanq-sartelle-reveal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.flqsrvReady === 'true') return;
      root.dataset.flqsrvReady = 'true';

      const controls = [...root.querySelectorAll('[data-reveal-control]')];
      const states = [...root.querySelectorAll('[data-reveal-state]')];
      const caption = root.querySelector('[data-reveal-caption]');
      const captions = {
        object: root.dataset.objectCaption || '',
        body: root.dataset.bodyCaption || ''
      };

      const show = (name) => {
        states.forEach((state) => {
          const selected = state.dataset.revealState === name;
          state.hidden = !selected;
          state.classList.toggle('is-active', selected);
        });
        controls.forEach((control) => {
          const selected = control.dataset.revealControl === name;
          control.classList.toggle('is-selected', selected);
          control.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (caption) caption.textContent = captions[name] || '';
      };

      controls.forEach((control) => control.addEventListener('click', () => show(control.dataset.revealControl)));
      show('object');
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-flqsrv-reveal]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
